/**
 * Created by XuQiang on 2017/5/23.
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import '../../style/s.css';

const ewm60 = require('../../assets/ewm60.png');

export default () => (
  <div className="footer">
    <div className="footer-outer_con">
      <div className="footer-outer">
        <div className="footer-inner">
          <span className="weight">
            <FormattedMessage id="product_categories" />
          </span>
          <br />
          <a href="http://www.virsical.cn/meeting.html">
            <FormattedMessage id="smart_conference" />
          </a>
          <br />
          <a href="http://www.virsical.cn/vistors.html">
            <FormattedMessage id="access_management" />
          </a>
          <br />
          <a href="http://www.virsical.cn/workspace.html">
            <FormattedMessage id="smart_cubicle" />
          </a>
          <br />
          <a href="http://www.virsical.cn/signage.html">
            <FormattedMessage id="smart_signage" />
          </a>
          <br />
          <a href="http://www.virsical.cn/vscall.html">
            <FormattedMessage id="index_bottom_13" />
          </a>
          <br />
          <a href="http://www.virsical.cn/portal.html">
            <FormattedMessage id="smart_office_portal" />
          </a>
          <br />
        </div>
        <div className="footer-inner">
          <a href="http://www.virsical.cn/download/" className="weight">
            <FormattedMessage id="download" />
          </a>
          <br />
          <a href="http://www.virsical.cn/download/#wsk">
            <FormattedMessage id="download_virsical" />
          </a>
          <br />
          <a href="http://www.virsical.cn/download/#vHua">
            <FormattedMessage id="download_v_chat" />
          </a>
          <br />
          <a href="http://www.virsical.cn/download/#zhanban">
            <FormattedMessage id="download_smart_signage" />
          </a>
          <br />
        </div>
        <div className="footer-inner">
          <a href="http://www.virsical.cn/resources.html" className="weight">
            <FormattedMessage id="rsources" />
          </a>
          <br />
          <a href="http://www.virsical.cn/resources.html">
            <FormattedMessage id="download_product" />
          </a>
          <br />
          <a href="http://www.virsical.cn/resources.html#case_solve">
            <FormattedMessage id="download_typical" />
          </a>
          <br />
        </div>
        <div className="footer-inner">
          <span className="weight">
            <FormattedMessage id="interactive_center" />
          </span>
          <br />
          <a href="http://www.virsical.cn/video.html">
            <FormattedMessage id="video_center" />
          </a>
          <br />
          <a href="http://www.virsical.cn/help-virsical.html">
            <FormattedMessage id="virsical_help_center" />
          </a>
          <br />
        </div>
        <div className="footer-inner">
          <a href="http://www.virsical.cn/about.html" className="weight">
            <FormattedMessage id="index_bottom_20" />
          </a>
          <br />
          <a href="http://www.virsical.cn/about.html#brief">
            <FormattedMessage id="company_profile" />
          </a>
          <br />
          <a href="http://www.virsical.cn/about.html#partner">
            <FormattedMessage id="partners" />
          </a>
          <br />
          <a href="http://www.virsical.cn/about.html#aptitude">
            <FormattedMessage id="honors_qualifications" />
          </a>
          <br />
          <a href="http://www.virsical.cn/about.html#news">
            <FormattedMessage id="news" />
          </a>
          <br />
          <a href="http://www.virsical.cn/jobs.html">
            <FormattedMessage id="recruitment" />
          </a>
          <br />
          <a href="http://www.virsical.cn/about.html#contacts">
            <FormattedMessage id="index_bottom_24" />
          </a>
          <br />
        </div>
        <div className="footer-inner code fz14 tc">
          <p>
            <FormattedMessage id="index_bottom_55" />
          </p>
          <p>
            <FormattedMessage id="index_bottom_56" />
          </p>
          <div className="qr_code">
            <img src={ewm60} />
          </div>
        </div>
        <div className="clearfix" />
        <div className="footer-company fz14 tc">
          © <FormattedMessage id="index_bottom_30" /> &{' '}
          <FormattedMessage id="index_bottom_31" />
        </div>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/login/ReservationBottomSection.js